import * as React from "react";
const SvgIcArrowLeftWh = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 10, width: 10, ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "10,0 10,10 0,5", style: {
  fill: "white",
  stroke: "white",
  strokeWidth: 1
} }));
export default SvgIcArrowLeftWh;
